import { InquiryOfferState } from '@synergy/models';

const translationObject: { [Key in InquiryOfferState]: string } = {
    [InquiryOfferState.Open]: 'app.inquiryOfferState.open',
    [InquiryOfferState.OnGoing]: 'app.inquiryOfferState.onGoing',
    [InquiryOfferState.Declined]: 'app.inquiryOfferState.declined',
    [InquiryOfferState.Closed]: 'app.inquiryOfferState.closed',
};

export const getInquiryOfferStateTranslationId = (status?: InquiryOfferState): string => {
    return (status && translationObject[status]) || 'missing id';
};
